import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { OpgaveService } from "../shared/opgave.service";
import { OpgaveListeViewModel } from "./model/opgave-liste.view-model";

@Injectable({ providedIn: "root" })
export class OpgaveListeSandbox {
    constructor(private readonly service: OpgaveService) {}

    public hentViewModel(): Observable<OpgaveListeViewModel> {
        const opgaver$ = this.service.hentOpgaver();
        const maalerOplysninger$ = this.service.hentMaalerOplysningerForAktuelInstallation();
        const indstillinger$ = this.service.hentIndstillinger();
        return combineLatest([opgaver$, maalerOplysninger$, indstillinger$]).pipe(
            map(([opgaver, maalerOplysninger, indstillinger]) => ({
                opgaver,
                maalerOplysninger,
                sideTitel: indstillinger.sideTitel
            })),
            shareReplay(1)
        );
    }
}
